import React, { useContext } from "react";
import Styles from "./AppRedirectPayBtn.module.scss";
import PriceIcon from "@vahak/core/dist/standard-icons/payment-coin.svg";
import Button from "@vahak/core-ui/dist/components/Button";
import { AppContext } from "@vahak/core/dist/app-context";

interface AppRedirectPayBtnProps {
    fullWidth?: boolean;
    type: "pay" | "receive";
}

const AppRedirectPayBtn = ({ fullWidth, type }: AppRedirectPayBtnProps) => {
    const { setShowAppRedirectionPopup } = useContext(AppContext);
    const showAppRedirectionModal = () => {
        setShowAppRedirectionPopup?.(true, {
            body: "Please download the app to continue your transaction"
        });
    };
    return (
        <div className={Styles.main}>
            <Button
                width={fullWidth ? "100%" : 120}
                onClick={(e) => {
                    e.stopPropagation();
                    showAppRedirectionModal?.();
                }}
                mSize="s"
            >
                {type === "pay" && (
                    <>
                        <PriceIcon />
                        Pay now
                    </>
                )}
                {type === "receive" && <>Receive payment</>}
            </Button>
        </div>
    );
};

export default AppRedirectPayBtn;
